<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import ObjectOfExpenditures from "@/components/tables/ooe-with-actions.vue";
import { map, uniqueId, groupBy } from "lodash";

export default {
  components: {
    Layout,
    PageHeader,
    Multiselect,
    ObjectOfExpenditures,
    PrintOptions: () =>
      import(/* webpackPrefetch: true */ "@/components/modals/print-options"),
    DeliveryUnitTemplate: () =>
      import(
        /* webpackPrefetch: true */ "@/components/tables/template-deliveryUnit.vue"
      ),
  },
  page: {
    title: "Finance Planning",
  },
  data() {
    return {
      title: "Finance Planning",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Finance Planning",
          active: true,
        },
      ],
      fundSources: [],
      openFS: false,
      selectedFS: null,
      filterFS: "",
      selectedFundSource: null,
      templates: [],
      loadingTemplate: false,
      templateDoneLoading: false,
      templateDeliveryUnits: [],
      templateOOEs: [],
      loadingOOE: false,
      loadDU: false,
      selectedTemplate: null,
      loadingFS: false,
      accountLoading: false,
      availableAccounts: [],
      templateType: false,
    }
  },
  async created() {
    this.loadingFS = true;
    await this.getFundSources(this.$store.state.data.selectedCampus.id);
    this.loadingFS = false;
  },
  methods: {
    checkExpiry(data) {
      return new Date() < new Date(data) ? true : false;
    },
    async getAvailableAccounts(id){
      await this.$store
      .dispatch("financeTemplate/getAvailableAccounts", {
        financeTemplateId: id,
      })
      .then((response) => {
        if(response.error){
          return this.showToast(response.errorMessage, "error");
        }
        this.availableAccounts = map(response.data, (item) => ({
            id: uniqueId("fc_"),
            label: item.classification,
            children: item.accountGroups.map((group) => ({
              id: group.id,
              label: `${group.groupName} - (${group.accountType})`
            })),
        }));
      })
      .catch((e) => {
        this.showToast("Something went wrong. Cannot fetch available PREXCs", "error");
      });
    },
    async getFundSources(data) {
      await this.$store
        .dispatch("fundsource/GetActiveFundSourcesByCampusId", data)
        .then((res) => {
          if(res.data.error){
            return this.showToast(res.data.errorMessage, "error");
          }
          this.fundSources = res.data
        })
        .catch((err) => {
          this.showToast(
            "Failed to fetch fund sources. Please contact administrator",
            "error"
          );
        });
    },
    async changeCycle(cycle){
      this.templates = [];
      this.templateDoneLoading = false;
      this.selectedTemplate = null;
      this.loadingOOE = true;
      this.loadDU = true;
      if(this.selectedFS){
        this.loadingTemplate = true;
        await this.fetchTemplates(this.selectedFS.id, cycle)
        this.loadingTemplate = false;
        if(this.templates.length){
          await this.getOOEs();
          await this.getDUOOE();
        }
        else{
          this.createTemplate();
        }
      }
      this.loadingOOE = false;
      this.loadDU = false;
    },
    async changeCampus(campus) {
      this.templates = [];
      this.selectedTemplate = null;
      this.loadingFS = true;
      this.templateDoneLoading = false;
      this.selectedFS = null;
      await this.getFundSources(campus.id);
      this.loadingFS = false;
    },
    async fetchTemplates(id, cycle) {
      await this.$store
        .dispatch("financeTemplate/getPreplanning", {fundSourceId: id, cycle})
        .then((res) => {
          if(res.data.error){
            return this.showToast(res.data.errorMessage, "error");
          }
          this.templateDoneLoading = true;
          this.templates = res.data;
          this.selectedTemplate = res.data[0];
        })
        .catch(() => {
          this.showToast(
            "Failed to fetch Pre-planning. Please contact administrator",
            "error"
          );
        });
    },
    async selectFS(row) {
      this.selectedFS = row;
      this.loadingTemplate = true;
      this.loadDU = true;
      this.loadingOOE = true;
      await this.fetchTemplates(row.id, this.$store.state.data.cycle)
      this.loadingTemplate = false;
      if(this.templates.length){
        await this.loadOOE();
        // await this.getDUOOE();
      }
      else{
        this.createTemplate();
      }
      this.loadingOOE = false;
      this.loadDU = false;
    },
    async loadAvailableOOE(){
      this.accountLoading = true;
      await this.getAvailableAccounts(this.selectedTemplate.id);
      this.accountLoading = false;
    },
    printLIB() {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/PrePlanning/Campus/LIB",
        routeVariables: [this.$store.state.data.selectedCampus.id, this.$store.state.data.cycle],
      });
      this.$bvModal.show("print-options-modal");
    },
    printOPCR(data) {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/PrePlanning/OPCR",
        routeVariables: [this.$store.state.data.cycle, data],
      });
      this.$bvModal.show("print-options-modal");
    },
    printPPMP(data) {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/PrePlanning/All/PPMP/API",
        routeVariables: [data, this.$store.state.data.cycle],
      });
      this.$bvModal.show("print-options-modal");
    },
    printLIBbyFS() {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/PrePlanning/FundSource/LIB",
        routeVariables: [this.$store.state.data.cycle, this.selectedFS.id],
      });
      this.$bvModal.show("print-options-modal");
    },
    printLIBbyDU(data) {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/PrePlanning/LIB",
        routeVariables: [this.$store.state.data.cycle, data],
      });
      this.$bvModal.show("print-options-modal");
    },
    async createTemplate(){
      await this.$store
        .dispatch("financeTemplate/createFinanceTemplate", {
          title: `${this.selectedFS.sourceName} Template (${this.$store.state.data.cycle})`,
          fundSourceId: this.selectedFS.id,
          cycle: this.$store.state.data.cycle
        })
        .then((res) => {
          if(res.data.error){
            return this.showToast(res.data.errorMessage, "error");
          }
          this.templateDoneLoading = true;
          this.templates.push(res.data);
          this.selectedTemplate = res.data;
          this.templateOOEs = [];
          this.getAvailableAccounts(this.selectedTemplate.id);
          // this.showToast("Successfully created template", 'success')
        })
        .catch(() => {
          this.showToast(
            "Failed to fetch Pre-planning. Please contact administrator",
            "error"
          );
        });
    },
    async getOOEs(){
      this.loadingOOE = false;
      await this.loadOOE();
      this.loadingOOE = false;
    },
    async loadOOE(){
      await this.$store
        .dispatch("financeTemplate/getObjectExpenditurebyFinance", this.selectedTemplate.id)
        .then((response) => {
          if (response.data.error) {
            return this.showToast(response.data.error, "error");
          }
          this.templateOOEs = response.data.sort((a, b) => {
            return a.groupName.localeCompare(b.groupName);
          });
        });
    },
    async getDUOOE(){
      this.loadDU = true;
      await this.loadDeliveryUnits();
      this.loadDU = false;
    },
    async loadDeliveryUnits(){
      await this.$store
        .dispatch(
          "financeTemplate/getAllDeliveryUnitsByTemplate",
          this.selectedTemplate.id
        )
        .then((response) => {
          if (response.data.error) {
            return this.showToast(response.data.errorMessage, "error");
          }
          this.templateDeliveryUnits = response.data.map((item) => ({
            ...item,
            officeBudget: [],
            showDetails: false,
            isLoadingDetails: false,
          }));
        }).catch((error) => {
          this.showToast("Error fetching delivery units", "error");
        });
    },
    updateDeliveryUnit(id) {
      this.$store
        .dispatch("financeTemplate/getDeliveryUnitFigures", {
          financeTemplateId: this.selectedTemplate.id,
          deliveryUnitId: id,
        })
        .then((response) => {
          if (response.data.error) {
            this.showToast(response.data.error, "error");
            return;
          }
          this.templateDeliveryUnits.find((x) => x.id == id).totalAllocated =
            response.data.amount;
          this.templateDeliveryUnits.find((x) => x.id == id).totalUsed =
            response.data.totalUsed;
          this.templateDeliveryUnits.find((x) => x.id == id).remaining =
            response.data.balance;
        })
        .catch((error) => {
          this.showToast("Error fetching delivery unit figures", "error");
        });
    },
    postPreplanning(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        confirmButtonText: "Yes, post it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("financeTemplate/postPrePlanning", id)
            .then(() => {
              this.selectedTemplate.status = "POSTED";
              this.showToast("Pre-planning posted successfully", "success");
            })
            .catch(() => {
              this.showToast(
                "Failed to post Pre-planning. Please contact administrator",
                "error"
              );
            });
        }
      });
    },
    deleteItem(row){
      if(row.allocated > 0){
        return this.showToast("Cannot delete OOE with allocated amount", "error");
      }
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("financeTemplate/deleteObjectOfExpenditure", row.groupId)
            .then((res) => {
              if(res.data.error){
                return this.showToast(res.data.errorMessage, "error");
              }
              let index = this.templateOOEs.findIndex((x) => x.groupId == row.groupId);
              this.templateOOEs.splice(index, 1);
              this.showToast("Remove successfully", "success");
            })
            .catch(() => {
              this.showToast(
                "Failed to delete. Please contact administrator",
                "error"
              );
            });
        }
      });
    },
    printRAOS(row){

    },
    editTemplate(){
      this.templateType = this.selectedTemplate.isBottomUp;
      this.$bvModal.show('template-modal');
    },
    updateTemplate(){
      this.$store
        .dispatch("financeTemplate/updateFinanceTemplate", {
          id: this.selectedTemplate.id,
          data: {...this.selectedTemplate, isBottomUp: this.templateType}
        })
        .then((res) => {
          if(res.data.error){
            return this.showToast(res.data.errorMessage, "error");
          }
          this.selectedTemplate.isBottomUp = this.templateType;
          this.$bvModal.hide('template-modal');
          this.showToast("Successfully updated", "success");
        })
        .catch(() => {
          this.showToast(
            "Failed to delete. Please contact administrator",
            "error"
          );
        });
    }
  },
  
}
</script>
<template>
    <Layout @changeCampus="changeCampus" @changeCycle="changeCycle">
      <PageHeader :title="title" :items="items" />
      <div class="d-flex justify-content-between">
        <div class="w-25 d-flex align-items-center">
          <h6 class="card-title mb-0 no-wrap me-1">Fund Sources:</h6>
          <template v-if="loadingFS">Loading...</template>
          <multiselect
            v-model="selectedFundSource"
            placeholder="Select fund source..."
            :options="fundSources"
            :searchable="true"
            :close-on-select="true"
            track-by="id"
            :show-labels="false"
            label="sourceName"

            @input="selectFS"
            v-else
          >
          </multiselect>
        </div>
        <div>
          <b-button
            v-if="selectedTemplate && !selectedTemplate.status"
            variant="outline-success"
            @click="editTemplate"
            class="me-2"
          >
            <i class="bx bx-edit align-middle me-2"></i> Edit Template
          </b-button>
          <b-dropdown
            right
            variant="outline-info"
            toggle-class="text-decoration-none"
            menu-class="dropdown-menu-end"
            no-caret
            v-if="selectedTemplate"
            class="me-2"
          >
            <template #button-content>
              Print LIB
              <i class="bx bx-down-arrow-circle align-middle ms-2 font-size-14"></i>
            </template>
            <b-dropdown-item @click="printLIB" size="sm"
              ><i class="bx bx-building font-size-18 me-1"></i>Per {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}
            </b-dropdown-item>
            <b-dropdown-item size="sm" @click="printLIBbyFS" v-if="selectedFundSource"
              ><i class="bx bx-money font-size-18 me-1"></i>Per Fund Source
            </b-dropdown-item>
          </b-dropdown>
          <b-button
            v-if="selectedTemplate && !selectedTemplate.status"
            variant="success"
            @click="postPreplanning(selectedTemplate.id)"
          >
            <i class="bx bx-send align-middle me-2"></i> Post Now
          </b-button>
        </div>
      </div>
      <!-- <div v-if="loadingTemplate" class="mt-2">
        <p class="mb-0 font">Loading Template...</p>
      </div>
      <div v-if="templateDoneLoading && templates.length == 0" class="mt-2">
        <div class="alert alert-warning alert-dismissible fade show">
          <i class="bx bx-info-circle me-2"></i> No template found. <a href="javascript:void(0);" @click="createTemplate">Click here to create.</a>
        </div>
      </div> -->
      <div class="mt-2" v-if="templateDoneLoading && templates.length">
        <b-tabs>
          <b-tab>
            <template #title>
              <i class="bx bx-doughnut-chart me-3 align-middle"></i>Object Of
              Expenditures
            </template>
            <div class="mt-3">
              <ObjectOfExpenditures 
                :objectOfExpenditures="templateOOEs"
                :template="selectedTemplate ? selectedTemplate.id : 0"
                :oeTableBusy="loadingOOE"
                :accountLoading="accountLoading"
                :availableAccounts="availableAccounts"
                @refreshData="getOOEs"
                @deleteItem="deleteItem"
                @print="printRAOS"
                @refresh-available="loadAvailableOOE"
              />
            </div>
          </b-tab>
          <b-tab lazy @click="getDUOOE">
            <template #title>
              <i class="bx bx-buildings me-3 align-middle"></i>Delivery Units
            </template>
            <DeliveryUnitTemplate
              :deliveryUnits="templateDeliveryUnits"
              :template="selectedTemplate ? selectedTemplate.id : 0"
              @update="updateDeliveryUnit"
              @lib="printLIB"
              @opcr="printOPCR"
              @ppmp="printPPMP"
              class="mt-3"
              :load="loadDU"
            />
          </b-tab>
        </b-tabs>
      </div>
      <print-options ref="printOpt"></print-options>
      <b-modal
        id="template-modal"
        title="Edit Template"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
      >
        <div class="d-flex px-3" style="gap:10px">
          <div 
            class="border border-success w-50 d-flex align-items-center justify-content-center py-5 cursor-pointer border-3"
            :class="{'template-selected': !templateType}"
            style="border-radius:15px;"
            @click="templateType = false"
          >
            <div class="text-center">
              <i 
                class="d-block bx bx-sort-down font-size-40"
                :class="{'text-success': templateType, 'text-white': !templateType}"
              ></i>
              <span class="font-size-16">Top Down</span>
            </div>
          </div>
          <div 
            class="border border-success w-50 d-flex align-items-center justify-content-center py-5 cursor-pointer border-3"
            :class="{'template-selected': templateType}"
            style="border-radius:15px;"
            @click="templateType = true"
          >
            <div class="text-center">
              <i 
                class="d-block bx bx-sort-up font-size-40"
                :class="{'text-success': !templateType, 'text-white': templateType}"
              ></i>
              <span class="font-size-16">Bottom Up</span>
            </div>
          </div>
        </div>
        <div class="px-3 mt-3">
          <button type="button" class="btn btn-block btn-primary" @click="updateTemplate">Update Template</button>
        </div>
      </b-modal>
    </Layout>
</template>